<template>
  <div class="grid gap-4 lg:col-span-1" v-if="user">
    <!-- <div class="bg-gray-900 bg-opacity-50 rounded-md mt-4 p-2">
              
                <div class="text-center">
                    <p class="mt-1 text-6xl font-extrabold text-gray-50">Find Your Home</p>
                    <p class="-mt-4 text-xl text-gray-200">Search, History and Favorite</p>
                </div>

     
                <button @click="displaySearch" class="uppercase ml-1 cursor-pointer w-full flex justify-center items-center px-4 py-2 shadow-sm text-sm font-medium rounded-lg text-gray-100 bg-indigo-700 hover:bg-indigo-900">
                    <svg class="mr-1 h-4 w-4 text-gray-50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                    </svg> 
                    Click to search
                </button>
        
           </div> -->

    <div class="border-double border-4 border-gray-700 rounded-md">
      <div
        class="bg-opacity-50 bg-black sm:p-2 rounded-md hover:bg-opacity-75 transition"
      >
        <div class="p-2 mb-4">
          <h3
            class="text-center mb-4 text-lg leading-6 font-medium text-gray-50"
          >
            Profile
          </h3>

          <v-text-field
            color="#2196F3"
            dark
            v-model="user.name"
            prepend-icon="mdi-account"
            label="Name"
            required
          ></v-text-field>

          <v-text-field
            color="#2196F3"
            dark
            v-model="user.email"
            prepend-icon="mdi-email"
            label="Email"
            required
          ></v-text-field>

          <v-text-field
            color="#2196F3"
            dark
            v-model="user.phone"
            prepend-icon="mdi-phone"
            label="Phone"
            required
          ></v-text-field>

          <div class="pt-5">
            <div class="flex justify-end">
              <button
                type="button"
                @click="updateUser(user)"
                class="inline-flex justify-center py-1 px-3 shadow-sm text-sm font-medium rounded-lg text-white bg-green-600 hover:bg-green-700 focus:outline-none"
              >
                Save
              </button>
              <button
                @click="displayProfile"
                class="ml-2 py-1 px-3 text-sm font-base text-white bg-blue-600 hover:bg-blue-700 rounded-md focus:outline-none "
              >
                More Info <i class="text-white ml-1 fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  name: "Buyer-Menu",

  props: ["user", "docs"],

  data() {
    return {
      bgurl: "https://ui-avatars.com/api/?name=",
      rest: "&background=ccf3ff&color=0099cc",
      url: process.env.VUE_APP_API_URL_FILES
    };
  },

  methods: {
    displayProfile() {
      this.$emit("showProfile");
    },

    displayDocs() {
      this.$emit("showDocs");
    },

    displaySearch() {
      //this.$emit('showSearch')
      this.$router.push({ name: "listings" });
    },

    redirectSearch() {
      this.$emit("showSearch");
    },

    updateUser(user) {
      window.axios
        .post("/api/updateUser", {
          id: user.id,
          name: user.name,
          email: user.email,
          phone: user.phone
        })
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "User successfully updated"
          });
          this.$store.dispatch("getUser");
        });
    }
  }
};
</script>
